
























































import { defineComponent, PropType, useRoute, useRouter } from '@nuxtjs/composition-api';
import { isEqual } from 'lodash-es';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useStaffFormatDate } from '~/composables/staff/useStaffFormatDate';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { BOTTLE_200 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import scrollToTop from '~/utils/scrollToTop';
import { StaffReview } from '~/types/modules/staff';

export default defineComponent({
  components: {
    AppImage,
    AppLink,
  },
  props: {
    review: {
      type: Object as PropType<StaffReview>,
      required: true,
    },
    noImage: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { IMAGE_WAVE_URL } = useRuntimeConfig();
    const { formatDate } = useStaffFormatDate();

    const applyFilter = async (tag: number) => {
      const tagAsString = tag.toString();

      if (route.value.query._tag?.includes(tagAsString)) return;

      if (!isEqual(url('STAFF_REVIEW_LIST'), route.value.path)) {
        await router.push({ path: url('STAFF_REVIEW_LIST'), query: { _tag: tagAsString } });
      } else {
        await router.replace({ query: { _tag: tagAsString } });
        scrollToTop();
      }
    };

    return {
      formatDate,
      url,
      applyFilter,
      BOTTLE_200,
      IMAGE_WAVE_URL,
    };
  },
});
